import UiButton from 'ui-components/ui-button/UiButton';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { StyledDialog } from './UiConfirmDialog.styles';

const DialogTitle = withStyles(() => ({
  root: {
    fontFamily: 'inherit !important',
  },
}))(MuiDialogTitle);

const DialogContent = withStyles(() => ({
  root: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: '24px',
    paddingTop: '4px !important',
  },
}))(MuiDialogContent);

const DialogActions = withStyles(() => ({
  root: {
    justifyContent: 'space-evenly',
  },
}))(MuiDialogActions);

const UiConfirmDialog = (props) => {
  const { t } = useTranslation();
  const {
    open,
    title,
    children,
    onCancel = () => {},
    cancelTitle = t('common:cancel'),
    confirmTitle = t('common:confirm'),
    onConfirm = () => {},
    actions,
    className,
    ...rest
  } = props;
  return (
    <StyledDialog
      open={open}
      onClose={onCancel}
      {...rest}
      className={classNames('question-dialog', className)}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>

      <DialogActions className='question-dialog-actions'>
        {!actions ? (
          <>
            <UiButton
              autoFocus
              variant='text'
              onClick={onCancel}
              color='primary'
            >
              {cancelTitle}
            </UiButton>
            <UiButton variant='contained' onClick={onConfirm} color='primary'>
              {confirmTitle}
            </UiButton>
          </>
        ) : (
          actions
        )}
      </DialogActions>
    </StyledDialog>
  );
};

UiConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  cancelTitle: PropTypes.string,
  confirmTitle: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
};

export default UiConfirmDialog;
